import React from "react";
import Container from "react-bootstrap/Container";
import classes from "./CarSkill.module.css";

const ContainerCardSkill = ({ children }) => {
  return (
    <Container fluid className={classes.ContainerCardSkill}>
      {children}
    </Container>
  );
};

export default ContainerCardSkill;
